import OToaster from './OToaster.vue'

export default OToaster
